import { render, staticRenderFns } from "./lastFags.vue?vue&type=template&id=8b44843e&"
import script from "./lastFags.vue?vue&type=script&lang=js&"
export * from "./lastFags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports